import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";

// Page dédiée aux informations de compte (identité, contact) — distincte de /profile qui ne
// gère que la présentation publique (bio, photo, passions...). Le nom est stocké en un seul
// champ côté base (`name`) : on le sépare ici en Prénom/Nom pour l'édition, puis on le
// recombine à l'enregistrement, sans toucher au schéma ni à tout ce qui affiche déjà `name`.
export default function Account() {
  const { user, setUser } = useApp();
  const navigate = useNavigate();
  const nameParts = (user?.name || "").trim().split(" ");

  const [firstName, setFirstName] = useState(nameParts[0] || "");
  const [lastName, setLastName] = useState(nameParts.slice(1).join(" "));
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const save = async () => {
    const fullName = `${firstName.trim()} ${lastName.trim()}`.trim();
    if (!fullName) { setError("Le prénom est obligatoire"); return; }
    setSaving(true);
    setMessage("");
    setError("");
    try {
      const data = await api.put("/users/me", { name: fullName, email, phone });
      if (data?.error) {
        setError(data.error);
      } else {
        setUser({ ...user, name: fullName, email, phone });
        setMessage("Modifications enregistrées");
      }
    } catch {
      setError("Erreur de connexion");
    } finally {
      setSaving(false);
    }
  };

  const card: React.CSSProperties = { backgroundColor: "white", borderRadius: 16, padding: 20, border: "1px solid #F0F0F0", marginBottom: 12 };
  const inputStyle: React.CSSProperties = { width: "100%", padding: "11px 14px", borderRadius: 10, border: "1px solid #E0E0E0", fontSize: 14, outline: "none", boxSizing: "border-box" };
  const labelStyle: React.CSSProperties = { fontSize: 12, fontWeight: 600, color: "#666", display: "block", marginBottom: 6 };

  return (
    <div style={{ maxWidth: 560, margin: "0 auto", padding: "20px 20px 40px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
        <button onClick={() => navigate("/settings")} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 20, padding: 0, display: "flex" }}>←</button>
        <h1 style={{ fontSize: 20, fontWeight: 800, margin: 0 }}>Compte</h1>
      </div>
      <p style={{ fontSize: 13, color: "#999", marginBottom: 20 }}>Vos informations d'identité et de contact.</p>

      <div style={card}>
        <label style={labelStyle}>Prénom</label>
        <input style={{ ...inputStyle, marginBottom: 14 }} value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="Prénom" />
        <label style={labelStyle}>Nom</label>
        <input style={inputStyle} value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Nom" />
      </div>

      <div style={card}>
        <label style={labelStyle}>Email</label>
        <input type="email" style={{ ...inputStyle, marginBottom: 14 }} value={email} onChange={e => setEmail(e.target.value)} placeholder="email@exemple.com" />
        <label style={labelStyle}>Téléphone</label>
        <input type="tel" style={inputStyle} value={phone} onChange={e => setPhone(e.target.value)} placeholder="+33 6 12 34 56 78" />
      </div>

      {error && <div style={{ color: "#c0392b", fontSize: 13, marginBottom: 12 }}>{error}</div>}
      {message && <div style={{ color: "#1D9E75", fontSize: 13, marginBottom: 12 }}>{message}</div>}

      <button onClick={save} disabled={saving || !firstName.trim()} style={{ width: "100%", padding: "14px", borderRadius: 14, border: "none", backgroundColor: !firstName.trim() ? "#E0E0E0" : "#0a0a0a", color: "white", fontSize: 15, fontWeight: 700, cursor: saving ? "default" : "pointer" }}>
        {saving ? "Enregistrement..." : "Enregistrer"}
      </button>
    </div>
  );
}
